import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { useProfileStore } from 'src/features/stores/useProfileStore';
import { getAxios } from 'src/lib/axios';

const checkPersonalModeDisabledQuery = async (companyId: number): Promise<boolean> => {
  let url = `/api/ObtV2/CheckPersonalModeDisabled/?`;
  url += '&companyId=' + companyId;
  return (await getAxios().get(url, {})).data;
};

export const useCheckPersonalModeDisabledQuery = () => {
  const location = useLocation();
  const profileStore = useProfileStore();
  const selectedUser = profileStore.users?.find((u) => u.ContactId === profileStore.selectedUserId);
  const companyId = selectedUser ? selectedUser.CompanyId : undefined;
  return useQuery({
    queryKey: ['checkPersonalCardAvailableQuery', companyId, location],
    queryFn: () => checkPersonalModeDisabledQuery(companyId!),
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    enabled: !!companyId // <--- only runs when companyId is available
  });
};
